import React, {useState, useEffect, useRef} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import Portal from '../portal'
import {toRGB} from '../../helper/colors'
import styled from 'styled-components'

const ModalShowBox = styled.div`
  background: rgba(0, 0, 0, 0.60);
`
const ModalBoxWrapper = styled.div`
  //TODO: check the styles - is vertical center alignment is necessary as in Figma?
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  font-family: 'Basis Grotesque Pro';
  display: flex;
  width: 440px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  border: 1px solid var(--it-stroke-grey);
  background: var(--it-bg-dark-2);
`

function updateBodyFixed(isOpen){
    //TODO: check the logic with 'body.style.top' - is it necessary?
    let body = document.querySelector('body');
    if(isOpen) {
        /*body.style.top = `-${window.scrollY}px`;
        body.classList.add('fixed')*/
        body.classList.add('body-overflow-hidden')
    } else {
        /*body.classList.remove('fixed');
        window.scrollTo(0, parseInt(body.style.top || '0') * -1);
        body.style.top = ``;*/
        body.classList.remove('body-overflow-hidden')
    }
}

export const Modal = ({
                 className = '',
                 isOpen,
                 isModal = false,
                 children,
                 onClose,
                 width = '440px',
                 maxWidth = 'max-w-xs sm:max-w-sm lg:max-w-lg'
               }) => {
  const {backgroundTheme} = useSelector(
    (state) => ({
      backgroundTheme: state.uiConfig.backgroundTheme
    }),
    shallowEqual
  )

  const modalRef = useRef(null)

  useEffect(() => {
    if(isModal) return;
    const handleClickOutside = (event) => {
        if (!modalRef || !modalRef.current) return false
        if (!isOpen || modalRef.current.contains(event.target)) {
            return false
        }

        const modalRect = modalRef.current.getBoundingClientRect();
        const clickX = event.clientX;
        const clickY = event.clientY;

        const isOutside =
            clickX < modalRect.left ||
            clickX > modalRect.right ||
            clickY < modalRect.top ||
            clickY > modalRect.bottom;

        if (!isOutside) return false;

        //console.log('handleClickOutside:: Outside click!');
        onClose && onClose(!isOpen)
    }

    const handleKeyDown = (event) => {
      if (!isOpen) {
        return false
      }

      if (event.key === 'Escape') {
        //console.log('handleKeyDown:: Escape clicked!');
        onClose && onClose(!isOpen)
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen, modalRef])

  useEffect(()=>{
      updateBodyFixed(isOpen);
      return ()=>{
          updateBodyFixed(false);
      }
  }, [isOpen])

  if(!isOpen) return null;

  return (
      <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <ModalShowBox
            className={`modal show`}
            data-background={backgroundTheme}
          >
            <ModalBoxWrapper
              className={`relative w-auto lg:my-4 mx-auto ${maxWidth} ${className}`}
            >
              {/* <div className="bg-white text-grey-900 border-grey-200 dark:bg-grey-800 dark:text-white dark:border-grey-700 border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none">
                {children}
              </div> */}
              <ModalBox style={{width}} ref={modalRef}>
                { children }
              </ModalBox>
            </ModalBoxWrapper>
          </ModalShowBox>
    </Portal>
  )
}
